/*
 * App Service Messages
 * This contains all the text for the App Services.
 */
import { defineMessages } from 'react-intl';

const scope = 'app.service';

export default defineMessages({
  evaluationError: {
    id: `${scope}.evaluation.error`,
    defaultMessage: 'There was a technical problem checking your answer. If the issue keeps occurring, try refreshing your browser window.',
  },

});
